export function imageSrcset (src) {
  const image = window.__IMAGE_SIZES__ && window.__IMAGE_SIZES__[src]
  if (!image || !image.variants.length) return src
  const publicPath = __webpack_public_path__ // eslint-disable-line camelcase
  return image.variants.map(item => `${publicPath}${item.file} ${item.width}w`).join(', ')
}

export function imageAttrs (src, eager) {
  const attrs = { loading: eager ? 'eager' : 'lazy', decoding: 'async' }
  if (eager) attrs.fetchpriority = 'high'
  const image = window.__IMAGE_SIZES__ && window.__IMAGE_SIZES__[src]
  if (!image) return attrs
  attrs.width = image.width
  attrs.height = image.height
  if (image.variants.length) {
    attrs.srcset = imageSrcset(src)
    attrs.sizes = `(max-width: 680px) 100vw, ${image.width}px`
  }
  return attrs
}
